import React, { useState, useEffect } from "react";
import "../../index.css";

const initialData = [
  {
    id: 1,
    studentName: "Student 1",
    className: "10-A",
    session: "2024-25",
    feeFor: "School",
    amount: 2000,
    status: "Unpaid"
  }
];

export default function CollectFees() {

  const STORAGE_KEY = "feeCollection";

  const toggleSelect = (row) => {
    setSelected(selected?.id === row.id ? null : row);
  };

  const [list, setList] = useState([]);
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    studentName: "",
    className: "",
    session: "",
    feeFor: "",
    amount: "",
    status: "Unpaid"
  });

  // FILTER
  const filtered = list.filter(l =>
    l.studentName.toLowerCase().includes(search.toLowerCase())
  );

  // ADD
  const openAdd = () => {
    setIsEdit(false);
    setFormData({
      id: "",
      studentName: "",
      className: "",
      session: "",
      feeFor: "",
      amount: "",
      status: "Unpaid"
    });
    setShowModal(true);
  };

  // EDIT
  const openEdit = () => {
    if (!selected) return alert("Select record");
    setIsEdit(true);
    setFormData(selected);
    setShowModal(true);
  };

  // DELETE
  const handleDelete = () => {
    if (!selected) return alert("Select record");

    const updated = list.filter(l => l.id !== selected.id);
    setList(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));

    setSelected(null);
  };

  // SAVE
  const handleSave = () => {
    if (!formData.studentName || !formData.feeFor || !formData.amount) {
      return alert("All fields required");
    }

    let updated;

    if (isEdit) {
      updated = list.map(l =>
        l.id === formData.id ? formData : l
      );
    } else {
      updated = [{ ...formData, id: Date.now() }, ...list];
    }

    setList(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));

    setShowModal(false);
    setSelected(null);
  };

  // MARK PAID
  const markPaid = () => {
    if (!selected) return alert("Select record");

    const updated = list.map(l =>
      l.id === selected.id ? { ...l, status: "Paid" } : l
    );

    setList(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  // LOAD
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

    if (saved.length === 0) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(initialData));
      setList(initialData);
    } else {
      setList(saved);
    }
  }, []);

  return (
    <>
      <style>{`
        .page { background:#f5f7fb; padding:20px; }
        .card { background:#fff; padding:15px; border-radius:8px; }

        .header { display:flex; justify-content:space-between; margin-bottom:10px; }

        .controls { display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap; }

        .search-box { padding:8px; border:1px solid #ccc; border-radius:4px; }

        .btn { padding:7px 12px; border:none; border-radius:4px; cursor:pointer; }
        .btn-dark { background:#2c3e50; color:white; }
        .btn-blue { background:#3498db; color:white; }
        .btn-red { background:#e74c3c; color:white; }

        table { width:100%; border-collapse:collapse; }
        th, td { padding:10px; border-bottom:1px solid #eee; }

        tr:hover { background:#f4f6f9; cursor:pointer; }
        .active-row { background:#eef3ff; }

        .modal {
          position:fixed; top:0; left:0; width:100%; height:100%;
          background:rgba(0,0,0,0.5);
          display:flex; justify-content:center; align-items:center;
        }

        .modal-content {
          background:white; padding:20px; border-radius:8px; width:350px;
        }

        .modal-content input, .modal-content select {
          width:100%; margin-bottom:10px; padding:8px;
        }
      `}</style>

      <div className="page">
        <div className="card">

          <div className="header">
            <h3>Collect Fees</h3>
            <div>{list.length} Records</div>
          </div>

          <div className="controls">
            <input
              className="search-box"
              placeholder="Search Student"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <button className="btn btn-dark" onClick={openAdd}>+ Add</button>
            <button className="btn btn-blue" onClick={openEdit}>Update</button>
            <button className="btn btn-red" onClick={handleDelete}>Delete</button>
            <button className="btn btn-blue" onClick={markPaid}>Mark Paid</button>
          </div>

          <table>
            <thead>
              <tr>
                <th></th>
                <th>Student</th>
                <th>Class</th>
                <th>Session</th>
                <th>Fee For</th>
                <th>Amount</th>
                <th>Status</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map(l => (
                <tr
                  key={l.id}
                  className={selected?.id === l.id ? "active-row" : ""}
                  onClick={() => toggleSelect(l)}
                >
                  <td>
                    <input
                      type="checkbox"
                      checked={selected?.id === l.id}
                      onChange={() => toggleSelect(l)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td>
                  <td>{l.studentName}</td>
                  <td>{l.className}</td>
                  <td>{l.session}</td>
                  <td>{l.feeFor}</td>
                  <td>{l.amount}</td>
                  <td>{l.status}</td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>

        {/* MODAL */}
        {showModal && (
          <div className="modal">
            <div className="modal-content">

              <h3>{isEdit ? "Update Fee" : "Add Fee"}</h3>

              <input placeholder="Student Name"
                value={formData.studentName}
                onChange={(e) => setFormData({ ...formData, studentName: e.target.value })}
              />

              <input placeholder="Class"
                value={formData.className}
                onChange={(e) => setFormData({ ...formData, className: e.target.value })}
              />

              <input placeholder="Session"
                value={formData.session}
                onChange={(e) => setFormData({ ...formData, session: e.target.value })}
              />

              <select
                value={formData.feeFor}
                onChange={(e) => setFormData({ ...formData, feeFor: e.target.value })}
              >
                <option value="">Select Fee For</option>
                <option value="Transport">Transport</option>
                <option value="Admission">Admission</option>
                <option value="Hostel">Hostel</option>
                <option value="Book">Book</option>
                <option value="Dress">Dress</option>
                <option value="Other">Other</option>
              </select>

              <input type="number" placeholder="Amount"
                value={formData.amount}
                onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              />

              <div style={{ display: "flex", gap: "10px" }}>
                <button className="btn btn-blue" onClick={handleSave}>Save</button>
                <button className="btn btn-red" onClick={() => setShowModal(false)}>Cancel</button>
              </div>

            </div>
          </div>
        )}

      </div>
    </>
  );
}